export const SUBMITTALS_COUNT = 'SUBMITTALS_COUNT';
export const SUBMITTALS_LOAD = 'SUBMITTALS_LOAD';
